// iOS WebKit Polyfills
// This file provides polyfills for features that may not work on iOS Safari

// Polyfill for structuredClone if not available (iOS < 15.4)
if (typeof structuredClone === 'undefined') {
  (window as any).structuredClone = function(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  };
}

// Polyfill for queueMicrotask if not available
if (typeof queueMicrotask === 'undefined') {
  (window as any).queueMicrotask = function(callback: () => void) {
    Promise.resolve().then(callback).catch((e) =>
      setTimeout(() => {
        throw e;
      })
    );
  };
}

// Polyfill for requestIdleCallback (not available on iOS Safari)
if (typeof requestIdleCallback === 'undefined') {
  (window as any).requestIdleCallback = function(cb: IdleRequestCallback) {
    const start = Date.now();
    return setTimeout(() => {
      cb({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
      } as IdleDeadline);
    }, 1);
  };
  
  (window as any).cancelIdleCallback = function(id: number) {
    clearTimeout(id);
  };
}

// Ensure console methods exist (some older iOS versions)
if (typeof console === 'undefined') {
  (window as any).console = {
    log: () => {},
    warn: () => {},
    error: () => {},
    info: () => {},
    debug: () => {},
  };
}

// Polyfill for Array.prototype.at (iOS < 15.4)
if (!Array.prototype.at) {
  Array.prototype.at = function(index: number) {
    const len = this.length;
    const relativeIndex = index >= 0 ? index : len + index;
    if (relativeIndex < 0 || relativeIndex >= len) {
      return undefined;
    }
    return this[relativeIndex];
  };
}

// Prevent iOS from pausing execution when switching tabs
if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      console.log('Tab is now visible - app should continue running');
    }
  });
}

// Suppress ResizeObserver loop errors by wrapping ResizeObserver
// This prevents harmless errors from Radix UI Select components
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      const wrappedCallback = (entries: ResizeObserverEntry[], observer: ResizeObserver) => {
        try {
          callback(entries, observer);
        } catch (error: any) {
          // Suppress ResizeObserver loop errors
          if (error?.message?.includes('ResizeObserver') || 
              error?.message?.includes('loop')) {
            // Silently ignore - these are harmless
            return;
          }
          // Re-throw other errors
          throw error;
        }
      };
      super(wrappedCallback);
    }
  } as any;
}

console.log('iOS polyfills loaded successfully');

